export default __webpack_public_path__ + "static/media/water.f76c1272.webp";